module.exports = __webpack_public_path__ + "static/media/bar6.5fd7cf32.jpg";